<template>
  <modal :title="'Hello world'" :active.sync="active" :classModal="''">
    <div slot="header">
      <div class="vx-row flex text-primary justify-center m-2">
        <h3 class="text-primary">Edit Kapasitas Cluster</h3>
      </div>
    </div>
    <div class="vx-row m-0">
      <div class="flex flex-col w-full justify-center px-5">
        <div class="w-full">
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-1">
              <vs-input
                icon-no-border
                icon="icon icon-clock"
                icon-pack="feather"
                label-placeholder="Waktu Cluster"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                class="w-full"
                :value="cluster ? `${cluster.start_time} - ${cluster.end_time}` : null"
                :disabled="true"
              />
            </div>
          </div>
          <div class="vx-col w-full py-2 flex text-lg">
            <div class="flex-1">
              <vs-input
                name="username"
                icon-no-border
                icon="icon icon-user"
                icon-pack="feather"
                label-placeholder="Kapasitas"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                class="w-full"
                type="number"
                v-model="input.capacity"
              />
            </div>
          </div>
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="flex flex-col md:flex-row md:justify-end px-3 w-full">
        <vs-button @click="updateCapacity" class="w-full md:w-auto  mb-3" color="primary" type="filled">
          Update Kapasitas
        </vs-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue';
export default {
  name: "popup-edit-cluster-capacity",
  components : {
    Modal
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default : false
    },
    cluster: {
      type: Object,
      required: false,
      default: null
    }
  },
  data(){
    return {
      input: {
        capacity: this.cluster ? this.cluster.capacity : 0
      }
    }
  },
  watch: {
    active : function(){
      this.$emit('update:active', this.active)
    },
    cluster: {
      handler(){
        this.input.capacity = this.cluster.capacity;
      }
    }
  },
  methods : {
    cancelQueue() {
      var self = this;
      self.$vs.loading();
      self.$http
      .post(`/app/queue/cancel-queue`, {
        registration_code: self.$route.params.registration_code,
        cancel_type : self.cancelType
      })
      .then(() => {
        self.$vs.loading.close();
        self.$vs.notify({
            title: "Nomor antrian berhasil di batalkan !",
            color: "success",
            iconPack: "feather",
            icon: "icon-check"
        });
        window.setTimeout(function() {
          self.$router.push({ name: "antrian-online" });
        }, 500);
      })
      .catch(e => {
        self.$vs.loading.close();
        self.parseError(e);
      });
    },
    updateCapacity(){
      this.$vs.loading();
      this.$http.post(`/app/secure/service/updateCluster`, {
        start_time : this.cluster.start_time,
        end_time : this.cluster.end_time,
        capacity : this.input.capacity,
        cluster_id : this.cluster.id
      })
      .then(() => {
        this.$vs.loading.close();
        this.$emit('reloadData');
        this.$emit('update:active', false);

        this.$vs.notify({
          title: `Berhasil melakukan update kapasitas cluster`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position : "top-right"
        });
      })
      .catch(e => {
        this.parseError(e);
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },
  }
}
</script>